import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Card from "../../../components/Card";
import Users from "../../../components/Users";
import Balance from "../../../components/Balance";
import Chart from "./Chart";
import { getStudentStats } from "../../../services/dashboard.service";

const Overview = ({ className }) => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    currentYearTotal: 0,
    monthlyData: []
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await getStudentStats();
        setStats(data);
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques des élèves:', error);
        setStats({ total: 0, currentYearTotal: 0, monthlyData: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <Card
      className={cn(styles.card, className)}
      title="Total élève"
      classTitle={cn("title-green", styles.cardTitle)}
      classCardHead={styles.cardHead}
    >
      <div className={styles.overview}>
        <div className={styles.details}>
          <div className={cn("h4", styles.title)}>
            {loading ? "Chargement..." : `${stats.total.toLocaleString()} élèves`}
          </div>
          <div className={styles.line}>
            {!loading && (
              <div className={styles.subtitle}>
                {stats.currentYearTotal} nouveaux cette année
              </div>
            )}
          </div>
        </div>
        <Chart data={stats.monthlyData} loading={loading} />
      </div>
    </Card>
  );
};

export default Overview;
